<div id="picker" (dragover)="$event.preventDefault()" (drop)="onDrop($event)">
  <p class="file-upload-font" style="color: var(--green-900); margin-bottom: 0;">
    Drag & Drop or Choose a File to Upload
  </p>
  <p class="file-upload-font" style="color: var(--border-color);">
    PDF format only, up to 20 MB
  </p>

  <button type="button" class="file-upload-font file-button" (click)="fileInput.click()">
    Choose file
  </button>

  <input #fileInput type="file" accept=".pdf, application/pdf" hidden (change)="handleFileInput($event.target.files)" />
</div>